import styled from "styled-components";
import { Box, HeadingStyled, Span, SpanStyled, TextStyled } from "./Elements";
import { Spinner } from "react-bootstrap";

export const sliceProps = (props, sub) => {
  const { children, ...otherProps } = props;
  sub.forEach((prop) => delete otherProps[prop]);
  return otherProps;
};

export const ThemeLoader = () => {
  return (
    <Box className="d-flex justify-content-center align-items-center py-5">
      <Spinner className="main-spinner" />
    </Box>
  );
};

export const ButtonWithIcon = (props) => {
  const unwantedProps = ["icon", "label"];
  return (
    <ButtonWrapper
      {...sliceProps(props, unwantedProps)}
      className="d-flex align-items-center"
    >
      <button
        {...sliceProps(props, unwantedProps)}
        className={`header-btn ${!props.icon ? "Btn-icon" : ""} `}
        autoComplete="false"
      >
        {props.icon && <props.icon width="20px" />}
        <SpanStyled color="var(--WhiteColor)" size="14px">
          {props.label ? props.label : ""}
        </SpanStyled>
      </button>
    </ButtonWrapper>
  );
};

export const ContactButton = (props) => {
  const unwantedProps = ["icon", "label"];
  return (
    <ContactWrapper {...sliceProps(props, unwantedProps)}>
      <button
        className={`click-btn btn-style501 ${!props.icon ? "Btn-icon" : ""}`}
        autoComplete="false"
      >
        {props.icon && <props.icon width="22px" />}
        <HeadingStyled
          color={props?.color ? props?.color : ""}
          transform="math-auto"
          size="18px"
          weight="normal"
          className="text-nowrap button-label"
        >
          {props.label ? props.label : ""}
        </HeadingStyled>
        {props.iconAfter && <props.iconAfter width="22px" />}
      </button>
    </ContactWrapper>
  );
};

export const TextWithIcon = (props) => (
  <TextWithStyledWrapper
    color={props.color}
    className={`d-flex ${
      props.desc ? "align-items-start" : "align-items-center"
    }`}
  >
    <Box className="mx-2 d-flex align-items-center justify-content-center contact-svg">
      <props.icon width="20px" height="20px" />
    </Box>
    <Box>
      <Box
        className="mb-0 contact-text"
        size={props.headingSize ? props.headingSize : "14px"}
        color={!props.alsotextColor ? "var(--textGrey)" : "var(--textGrey)"}
        dangerouslySetInnerHTML={{ __html: props.title }}
      ></Box>
      {props.desc ? (
        <TextStyled
          className="text-uppercase"
          color={"var(--textgrey)"}
          size="14px"
        >
          {props?.desc}
        </TextStyled>
      ) : null}
    </Box>
  </TextWithStyledWrapper>
);

const TextWithStyledWrapper = styled.div`
  svg {
    [stroke] {
      stroke: ${({ color }) => (color ? color : "")};
    }
  }
`;

export const ContactWrapper = styled.div`
  button {
    display: flex;
    align-items: center;
    justify-content: ${(props) => (props.content ? props.content : "")};
    gap: 6px;
    height: 56px;
    padding: 0px 15px;
    border: none;
    border-radius: 8px;
    background: ${(props) => (props.bg ? props.bg : "var(--buttonColor)")};
    color: ${(props) => (props.color ? props.color : "var(--whiteColor)")};
    text-transform: capitalize;
    box-shadow: 0px 4px 8px 0px #064a9340;
    -webkit-box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.3);
    transition: all 0.4s ease-in-out;
    /* &:hover {
      background: var(--darkBlue);
      color: var(--whiteColor);
      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.3);
      -webkit-box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.3);
      -moz-box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.3);
    } */

    @media (max-width: 470px) {
      .button-label {
        font-size: 14px;
      }
    }
    body.rtl & {
      svg {
        transform: scale(-1);
      }
    }
  }
`;
export const ButtonWrapper = styled.div`
  button,
  button::after {
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    -o-transition: all 0.5s;
    transition: all 0.5s;
  }

  button {
    background: var(--themeColorSecondary);
    border: 1px solid var(--whiteColor);
    border-radius: 8px;
    color: var(--white);
    display: flex;
    gap: 8px;
    font-size: 15px;
    padding: 10px 14px;
    position: relative;
    text-transform: uppercase;
  }

  button:hover {
    opacity: 0.8;
  }
`;
